import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed,
} from '@angular/core';
import { ReferralStatus } from '@principle-theorem/principle-core/interfaces';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { IconChipComponent } from '@principle-theorem/ng-principle-shared';

interface IReferralStatusDisplay {
  icon: string;
  iconClass: string;
  label: string;
}

@Component({
  selector: 'pr-referral-status',
  imports: [NgCommonModule, IconChipComponent],
  templateUrl: './referral-status.component.html',
  styleUrl: './referral-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralStatusComponent {
  private readonly statusConfig: Record<
    ReferralStatus,
    IReferralStatusDisplay
  > = {
    [ReferralStatus.Draft]: {
      icon: 'edit',
      iconClass: 'text-slate-300',
      label: 'Draft',
    },
    [ReferralStatus.Sent]: {
      icon: 'send',
      iconClass: 'text-primary-500',
      label: 'Sent',
    },
    [ReferralStatus.Received]: {
      icon: 'inbox',
      iconClass: 'text-yellow-500',
      label: 'Received',
    },
    [ReferralStatus.Completed]: {
      icon: 'check_circle',
      iconClass: 'text-green-500',
      label: 'Completed',
    },
  };

  status = input.required<ReferralStatus>();
  statusInfo = computed(() => this.statusConfig[this.status()]);
}
